<template>
  <v-container id="scroll-0" fluid class="pa-1">
    <v-flex xs12 class="text-xs-center">
      <v-progress-circular v-if="loading" indeterminate v-bind:size="70" v-bind:width="7" color="primary"></v-progress-circular>
    </v-flex>
    <v-flex xs12 id="md-container" v-html="markdown" v-if="!notFound"></v-flex>
    <v-flex xs12 class="text-xs-center" v-else>
      <h4>Repositorio sin README =(</h4>
    </v-flex>

    <v-fab-transition>
      <v-btn
        color="primary"
        dark
        fab
        fixed
        bottom
        right
        v-scroll="onScroll"
        v-show="fab"
        @click="toTop"
      >
        <v-icon>keyboard_arrow_up</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-fab-transition>


  </v-container>
</template>

<style>
  img {
    max-width: 90%;
    margin-top: 10px;
  }
</style>



<script>
/* eslint-disable */
import marked from 'marked';
import highlightjs from 'highlight.js';
import 'highlight.js/styles/androidstudio.css';
import scrollTo from "scroll-into-view";

const renderer = new marked.Renderer();

renderer.heading = (text, level) =>
  `<h1 id="${text.toLowerCase().trim().replace(/\:/, '').replace(/ +/g, '-').replace(/[?¿]/g, '')}">${text}</h1>`;

renderer.link = (href, title, text) => 
  `<a href="${href}" class="m-link">${text}</a>`;

marked.setOptions({ renderer })

const REPO_BASE_URL = repo =>
  `https://raw.githubusercontent.com/joseahr/${repo}/master/README.md`;

export default {
  components: {
    //VueMarkdown,
  },
  data() {
    return {
      markdown: '',
      notFound: false,
      loading: true,
      fab: false
    };
  },
  methods: {
    getReadme(repo) {
      console.log(repo)
      this.$http.get(REPO_BASE_URL(repo))
        .then(res => res.text())
        .then((markdown) => {
          marked(markdown, { sanitize : true }, (err, mdParsed)=> {
            if(err) return;
            this.markdown = mdParsed;
          });
        })
        .catch(error => {
          if(error.status === 404){
            this.notFound = true;
          }
        })
        // Como un finally, catch devuelve una promesa también
        .then(() => { this.loading = false; });
    },
    highlight() {
      Array.from(document.querySelectorAll('pre code'))
      .forEach(node => highlightjs.highlightBlock(node))
    },
    onScroll() {
      if (typeof window === 'undefined') return;

      const top = window.pageYOffset ||
                  document.documentElement.offsetTop ||
                  0;
      //console.log(top)
      this.fab = top > 300;
    },
    toTop () {
      this.$router.push({ hash: '' })
      scrollTo(document.getElementById('scroll-0'), { time: 500 }, ()=> window.scrollTo(0,0) )
    },
  },
  created() {
    //console.log(this.$route.params.repoName);
    const { repoName } = this.$route.params;
    this.getReadme(repoName);
  },
  mounted () {
    this.$vuetify.load(this.onScroll);
    document.getElementById('md-container').addEventListener('click', e => {
      if(e.target.classList.contains('m-link')){
        console.log('clicked', e.target);
        e.preventDefault();
        const href = e.target.getAttribute('href').substring(1);
        //console.log(href)
        const el = document.getElementById(href);
        //console.log(el)
        scrollTo(el, { time: 1000 });
      }
    });
  },
  updated() {
    this.highlight();
  }
};
</script>



// WEBPACK FOOTER //
// MarkdownView.vue?14134766